import styled, { css } from 'styled-components';

export const Wrapper = styled.div``;

export const Tab = styled.div<{ $active: boolean }>`
  width: 130px;
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => `${theme.rounded.x4} ${theme.rounded.x4}`} 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  border-bottom: 2px solid #c4c4c4;
  background: ${({ theme }) => theme.palette.middGray2};
  opacity: 0.2;
  padding: ${({ theme }) => theme.spacing.x4};
  transition: 0.1s;
  cursor: pointer;
  ${({ $active }) =>
    $active
      ? css`
          background: ${({ theme }) => theme.palette.white};
          color: ${({ theme }) => theme.palette.secondary};
          border-color: ${({ theme }) => theme.palette.secondary};
          opacity: 1;
        `
      : null}
`;

export const InputWrapper = styled.div<{ $width: string | undefined }>`
  margin: -${({ theme }) => theme.spacing.x2};
  display: flex;
  flex-wrap: wrap;
  > * {
    padding: ${({ theme }) => theme.spacing.x2} 0px;
    ${({ $width }) =>
      $width == 'spend'
        ? css`
            width: 25%;
          `
        : css`
            width: 33.33333%;
          `}

    @media (max-width: ${({ theme }) => theme.media.sm}) {
      width: 100%;
    }
  }
`;
export const DepartureArrival = styled.div`
  flex-grow: 2;
`;

export const Item = styled.div`
  + * {
    margin-top: ${({ theme }) => theme.spacing.x2};
  }
`;
export const Row = styled.div`
  display: flex;
  > * {
    flex: 1;
  }
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-direction: column;
  }
`;

export const Content = styled.span<{ $color?: 'blue' | 'green' | 'red' }>`
  display: block;
  padding: 8px;
  ${({ $color }) =>
    $color === 'red'
      ? css`
          background: ${({ theme }) => theme.palette.error10};
          color: ${({ theme }) => theme.palette.error};
        `
      : $color === 'green'
      ? css`
          background: ${({ theme }) => theme.palette.greenLighter};
          color: ${({ theme }) => theme.palette.green};
        `
      : $color === 'blue'
      ? css`
          background: ${({ theme }) => theme.palette.blueLighter};
          color: ${({ theme }) => theme.palette.secondary};
        `
      : null};
`;

export const BorderedContent = styled(Content)`
  border: 1px solid ${({ theme }) => theme.palette.border};
`;
export const RedContent = styled(Content)``;

export const BlueContent = styled(Content)`
  background: ${({ theme }) => theme.palette.blueLighter};
  color: ${({ theme }) => theme.palette.secondary};
`;
export const GreenContent = styled(Content)`
  background: ${({ theme }) => theme.palette.greenLighter};
  color: ${({ theme }) => theme.palette.green};
`;

export const ButtonWrapper = styled.div`
  margin-inline-start: 0px !important;
`;

export const Button = styled.div`
  width: 147px;

  @media (max-width: ${({ theme }) => theme.media.xs}) {
    width: 100%;
  }
`;
